import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Entities } from '../../../../core/models/globals';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { HeaderService } from '../../../../core/services/header.service';
import { NavigationService } from '../../../../core/services/navigation.service';

@Component({
  selector: 'app-gateway-main-panel',
  templateUrl: './gateway-main-panel.component.html',
  styleUrls: ['./gateway-main-panel.component.scss']
})
export class GatewayMainPanelComponent implements OnInit {
  universalSub: Subscription;
  lastRefreshedTime: Date;
  currentEntity: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private configEntityService: ConfigEntityService,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.universalSub = this.navService.breadcrumbEntity.subscribe(x => {
      if (this.currentEntity != x) {
        this.currentEntity = x;
      }
    })
    if (this.currentEntity != Entities.Configurator) {
      this.navService.subNavData(Entities.Gateway);
    }
    if (this.currentEntity == Entities.Configurator) {
      this.navService.sendLeftPanelIndex(6);
      this.configEntityService.sendActiveEntity('Gateway')
      this.navService.sendChildData('Gateway')
      this.navService.sendParentData('')
    }
    //this.navService.subNavData(Entities.Gateway)
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe(x => {
      this.lastRefreshedTime = x
    })
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
